// extracted by mini-css-extract-plugin
export default {"model":"PopUp_model__48pE1","overlay":"PopUp_overlay__+2Wkv"};